var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":_vm.response.url,"method":"post","target":"_self"}},_vm._l((_vm.response.post),function(key,index){return _c('input',{key:index,attrs:{"type":"hidden","name":index},domProps:{"value":key}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }